import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { domainValueList } from "../../../../../../services/domainValue.service";

const translationPath = "4uESign.page.automations.automationRules.";

export const AuthorizationFields = memo(() => {
  const { t } = useTranslation();
  const { sendRequest: getDomainValues } = useFetch(domainValueList);
  const [authorizationTypes, setAuthorizationTypes] = useState<ISelectType[]>(
    [],
  );
  const [guideTypes, setGuideTypes] = useState<ISelectType[]>([]);
  const [authorizationStages, setAuthorizationStages] = useState<ISelectType[]>(
    [],
  );

  useEffect(() => {
    const fetchOptions = async () => {
      const [authorizationTypeResponse, guideTypeResponse, stageResponse] =
        await Promise.all([
          getDomainValues({ Identifier: 1377 }),
          getDomainValues({ Identifier: 1031 }),
          getDomainValues({ Identifier: 1378 }),
        ]);

      if (authorizationTypeResponse.success && authorizationTypeResponse.data) {
        setAuthorizationTypes(
          authorizationTypeResponse.data.map((item) => ({
            id: item.identifierValue,
            name: item.domainValueName,
            code: item.identifierValue,
          })),
        );
      }

      if (guideTypeResponse.success && guideTypeResponse.data) {
        setGuideTypes(
          guideTypeResponse.data.map((item) => ({
            id: item.identifierValue,
            name: item.domainValueName,
            code: item.identifierValue,
          })),
        );
      }

      if (stageResponse.success && stageResponse.data) {
        setAuthorizationStages(
          stageResponse.data
            .filter(
              (item) =>
                item.identifierValue !== "70" && item.identifierValue !== "90",
            )
            .map((item) => ({
              id: item.identifierValue,
              name: item.domainValueName,
              code: item.identifierValue,
            })),
        );
      }
    };

    fetchOptions();
  }, [getDomainValues]);

  return (
    <>
      <Grid item xs={12} sm={6}>
        <AutoCompleteMulti
          name="authorizationTypes"
          label={t(translationPath + "authorizationTypes")}
          options={authorizationTypes}
          getOptionLabel={(option) => option.name}
          size="small"
          fullWidth
          keepOpenOnSelect
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <AutoCompleteMulti
          name="guideTypes"
          label={t(translationPath + "guideTypes")}
          options={guideTypes}
          getOptionLabel={(option) => option.name}
          size="small"
          fullWidth
          keepOpenOnSelect
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <AutoCompleteMulti
          name="authorizationStages"
          label={t(translationPath + "authorizationStages")}
          options={authorizationStages}
          getOptionLabel={(option) => option.name}
          size="small"
          fullWidth
          keepOpenOnSelect
        />
      </Grid>
    </>
  );
});
